import React, { useState } from 'react'

import { Modal } from 'react-bootstrap'

import RequestService from "../../services/request.service";

import { SERVER_ } from  '../../config';

import { toast } from 'react-toastify'


const ModalAnexoMesa = (props) => {

	const { uuid_tramite, onHideModalAnexos, showModalAnexos } = props

	const [ anexos_digitales, setAnexos ] = useState<any>([])

	const cargarAnexos = async ()=>{
		try{
			let res = await RequestService.getEndPoint('mesa_tencion/anexos_digitales/'+uuid_tramite)
			setAnexos(res.data)
		}
		catch(e){
			toast.error('Error al cargar los anexos')
		}
	}

  React.useEffect(() => {
    cargarAnexos()
    cargarData()

  }, []);

const [ anexo_visualizar, setAnexoVisualizar ] = useState<string>('')
const [ anexo_para_subir, setAnexoSubir ] = useState<string>('')
const [ anexo_archivo_subir, setArchivoSubir ] = useState<any>('')

// const setAnexoVer = (anexo:string)=>{
//   setAnexoVisualizar(anexo)
// }
	
	const [ ficha_data, setFichaData ] = useState<any>({
		folio : "",
		idusuario : {
			nombres : '',
			paterno : '',
			materno : '',
			email : '',
			celular : '',
		},
		idgerente : {
			nombres : '',
			paterno : '',
			materno : '',
			email : '',
			celular : '',
		},
		idestatus : {
			id : 0,
			estatus : ""
		},
		idciudadano: {
		    uuid : "",
		    curp : "",
		    rfc : "",
		    fecha_nacimiento : "",
		    nombres : "",
		    paterno : "",
		    materno : "",
		    sexo : "",
		    seguro_social : "",
		    direccion : "",
		    colonia : "",
		    cp : "",
		    telefono : "",
		    celular : "",
		    email : ""
		  },
		  idsucursal : {
		  	nombre_sucursal : ""
		  },
		  historial_estatus : [],
		  depto_estrategias : {				
				semanas_cotizadas : "",
				fecha_aseguramiento: "",
				idafore : {
					afore : ""
				},
				monto_rcv: 0,
				monto_aseguramiento: 0,
				monto_aseguramiento_final: 0,
				fecha_baja_anterior: "",
				fecha_alta_anterior: "",
				fecha_baja_nuevo: "",
				fecha_alta_nuevo: "",
		  },
		  aseguramiento_evidencia : {
		  	uuid : ""
		  }
	})

	const cargarData = async () => {
		try{
			let res = await RequestService.getEndPoint('tramite/ficha_tecnica/'+uuid_tramite)
			if(res.data){
				setFichaData(res.data)
			}
		}
		catch(e){
			toast.error('Error al cargar la información del trámite')
		}
	}




	return (

			<React.Fragment>

		      <Modal size="sm" show={showModalAnexos} onHide={onHideModalAnexos}>
		        <Modal.Header closeButton>
		          <Modal.Title>Anexos Digitales</Modal.Title>
		        </Modal.Header>
		        <Modal.Body>
		        	
				

                    <h4 className="titulares">Trámite</h4>
		        			<p className="text-center">FOLIO <b>{ficha_data.folio}</b></p>





									        	

						{
							// JSON.stringify(anexos_digitales)
						}

						<ul className="list-group list-group-flush">

							{
								anexos_digitales.map( (anexo:any) => 
									<React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
										<li key={ Math.random().toString(36).substr(2, 9) } className="list-group-item">
											<a target="_blank" href={SERVER_+'anexo/'+anexo.uuid}> {anexo.idrequisito.requisito}</a>
										</li>
									</React.Fragment>

								)
							}

						</ul>


		        </Modal.Body>
		      </Modal>

			</React.Fragment>

		)

}

export default ModalAnexoMesa